import { render, staticRenderFns } from "./TopPickPreview.vue?vue&type=template&id=4a5f8120&"
import script from "./TopPickPreview.vue?vue&type=script&lang=js&"
export * from "./TopPickPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports